import { keyBy, keys } from 'lodash';

import { TFunction } from '@lyearn/i18n';
import { ListFill, TagFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { IconSettings } from '@/components/IconSettings';
import { IconSettings as IconSettingsType } from '@/types/schema';

import { SidebarListItem, SidebarStackItem } from '../../components/Sidebar/components/StacksMenu';
import { FileSearchResultFragment } from '../../graphql/fragments/generated/fileSearchResult';

export const getIcon = (iconSettings?: IconSettingsType | null, size = 20, className = '') => {
  if (iconSettings) {
    return (
      <IconSettings Icon={TagFill} className={className} iconSettings={iconSettings} size={size} />
    );
  }

  return <ListFill className={cn('flex-shrink-0', className)} height={size} width={size} />;
};

export default function getSidebarItems({
  t,
  stacks,
  lists,
}: {
  t: TFunction;
  stacks: FileSearchResultFragment[];
  lists: FileSearchResultFragment[];
}) {
  const listsById = keyBy(lists, 'id');
  const listIds = keys(listsById);
  const uncategorizedListIds = new Set(listIds);

  const sidebarItems: SidebarStackItem[] = [];

  for (const stack of stacks) {
    const subItems: SidebarListItem[] = [];
    for (const childId of stack.childrenIds || []) {
      const child = listsById[childId];
      if (child) {
        uncategorizedListIds.delete(child.id);
        subItems.push({
          id: child.id,
          label: child.name,
          iconSettings: child.iconSettings ?? undefined,
        });
      }
    }
    sidebarItems.push({
      id: stack.id,
      label: stack.name,
      iconSettings: stack.iconSettings ?? undefined,
      items: subItems.length > 0 ? subItems : undefined,
    });
  }

  if (uncategorizedListIds.size > 0) {
    sidebarItems.push({
      id: 'UNCATEGORIZED_LISTS',
      label: t('Task:List.UncategorizedLists'),
      iconSettings: undefined,
      items: Array.from(uncategorizedListIds).map((id) => {
        const list = listsById[id];
        return {
          id: list.id,
          label: list.name,
          iconSettings: list.iconSettings ?? undefined,
        };
      }),
    });
  }

  return sidebarItems;
}
